import { createAsyncThunk } from '@reduxjs/toolkit';

import { AppDispatch, RootState } from '../store';

type AppAsyncThunkConfig = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: unknown;
};

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();
